// extracted by mini-css-extract-plugin
module.exports = {"bg":"TopBar_bg__6ydVV","bgExpandedSolid":"TopBar_bgExpandedSolid__kCLu1","bgExpandedOpacity":"TopBar_bgExpandedOpacity__CLSt_"};